export default __webpack_public_path__ + "static/media/copyright.ccb7338b.svg";